const parsedJson = {
    klantgegevens: {
        KlantnummerPS: '15663',
        DbNrPS: '106057',
        DT_invoer: '2021-07-28 13:17:42',
        Email: 'bas@partnerselect.net',
        Bemiddelaar: 'Michelle',
        geslacht_zelf: 'V',
        achternaam: 'Bastest',
        Intaker: 'Liesbeth',
        firebase_id: 'yA34SgXLXMOUVAvvfDQv5msvSn53',
        Voornaam: 'Jan',
        Syncstatus_firebase: '0',
        Leeftijd: 20,
        persoonsbechrijving: {
            Relatornummer: '106057',
            DT_wijzig: '2021-08-25 16:45:16',
            PB: 'Gaat Renée als naam dan wel goed?\r\nTest voor óók Italië!\r\n\r\nHartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door. Hartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door. Hartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door. Hartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door. Hartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door. Hartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door. Hartelijk dank voor je inschrijving bij PartnerSelect! We gaan er alles aan doen om ervoor te zorgen dat je geen spijt van deze stap krijgt. Op naar een nieuwe relatie!\r\n\r\nZou je onderstaande gegevens nog kunnen controleren? Als er nog iets aangepast kan worden, geef het dan als antwoord op dit bericht aan ons door.\r\n',
            DT_PB: '2021-08-25 16:37:00',
        },
        foto2: 'https://mijn.partnerselect.net/pics_mijnps/9BAA83D7A53C6562A776E77F2C2BA98F7850B2A8_foto.jpg',
        foto: 'https://mijn.partnerselect.net/img/avatar-zelf-man.jpeg',
        aantal_extra_fotos: 3,
        extra_fotos: [
            {
                Volgorde: 10,
                Volgordegetal: 14,
                Bestandsnaam: 'https://webwereld.nl/cmsdata/features/3771708/je5jhttm7mmz6eq2_thumb800.jpg',
            },
            {
                Volgorde: 1,
                Volgordegetal: 1,
                Bestandsnaam:
                    'https://mijn.partnerselect.net/pics_mijnps/9BAA83D7A53C6562A776E77F2C2BA98F7850B2A8_foto.jpg',
            },
            {
                Volgorde: 1,
                Volgordegetal: 1,
                Bestandsnaam: 'https://webwereld.nl/cmsdata/features/3771708/je5jhttm7mmz6eq2_thumb800.jpg',
            },
        ],
    },
    algemene_berichten: [
        {
            Nr: 1,
            Bericht_actief: '1',
            DT_bericht_display_van: '2022-01-01 00:00:00',
            DT_bericht_display_tm: '2022-02-02 00:00:00',
            Type_bericht: '0',
            Onderwerp: 'TEST',
            Bericht: "Test bericht <a href='/reactietips'>testlink</a>",
        },
    ],
    berichten: [
        {
            Nummer: '280287',
            Klantnummer: '106057',
            Onderwerp: 'test naam',
            Bericht:
                'Beste Bas,\r\n\r\ntest\r\n\r\nMet vriendelijke groet,\r\n\r\nArjan\r\nbemiddelaar\r\n\r\n\r\n\r\n',
            Gelezen: '0',
            Afzender: 'PartnerSelect',
            DatumTijd: '2021-08-09 17:14:35',
            Notificatie: '0',
            Ontv_Verz: '0',
            Omw_code: '0',
        },
        {
            Nummer: '280288',
            Klantnummer: '106057',
            Onderwerp: 'test naam',
            Bericht:
                'Beste Bas,\r\n\r\ntest\r\n\r\nMet vriendelijke groet,\r\n\r\nArjan\r\nbemiddelaar\r\n\r\n\r\n\r\n',
            Gelezen: '0',
            Afzender: 'PartnerSelect',
            DatumTijd: '2021-08-09 17:14:35',
            Notificatie: '0',
            Ontv_Verz: '0',
            Omw_code: '0',
        },
        {
            Nummer: '279732',
            Klantnummer: '106057',
            Onderwerp: 'Foto Upload',
            Bericht:
                'Beste PartnerSelect, <br><br>Ik heb een (nieuwe) foto geupload met de volgende naam: <br><br>test-.jpg<br><br>',
            Gelezen: '0',
            Afzender: 'Zelf',
            DatumTijd: '2021-07-28 13:19:59',
            Notificatie: '0',
            Ontv_Verz: '1',
            Omw_code: '0',
        },
    ],
    voorstellen: [],
    // voorstellen: [
    //     {
    //         Klantnummer: '106057',
    //         KlantnummerREF: '8592',
    //         Voorstelnummer: '3108321',
    //         InschrijfnummerREF: '1913',
    //         DatumA: '2021-08-27 00:00:00',
    //         DatumAf: '2021-08-27 00:00:00',
    //         Voornaam: 'Testa',
    //         Openstaand: '1',
    //         Foto_code: '1',
    //         DT_foto_code_wijziging: '2021-09-22 11:09:52',
    //         Datum_Voorstel: '2021-08-27 00:00:00',
    //         persoonsbeschrijving_p2: {
    //             Relatornummer: '8592',
    //             DT_wijzig: '2021-07-23 16:48:34',
    //             PB: 'Hoi, zal ik me even voorstellen?\r\nIk ben Marloes, 38 jaar, 1 meter 80, blauwe ogen, lang bruin haar en een normaal postuur. Ik draag sportieve, vlotte casual kleding en kom graag goed verzorgd voor de dag. \r\n\r\nSamen met mijn dochter van 13, mijn zoon van 8 en onze hond woon ik in een lekkere, royale woning met een heerlijke tuin en garage.\r\n\r\nJe kunt me het beste beschrijven met woorden als aardig, vlot, opgewekt, makkelijk, humor, spontaan, gezellig, hartelijk, vrouwelijk, zelfverzekerd, sportief, realistisch, actief, avontuurlijk, dominant, levenservaren, materialistisch, zelfstandig, positief, innemend, modieus, representatief en jeugdig. Belangrijk om te weten is dat ik vrijwel altijd goed gehumeurd ben!\r\n\r\nJe kunt me het beste beschrijven met "woorden" als aardig, vlot, opgewekt, makkelijk, humor, spontaan, gezellig, hartelijk, vrouwelijk, zelfverzekerd, sportief, realistisch, actief, avontuurlijk, dominant, levenservaren, materialistisch, zelfstandig, positief, innemend, modieus, representatief en jeugdig. Belangrijk om te weten is dat ik vrijwel altijd goed gehumeurd ben!\r\n\r\nNa mijn opleiding op MBO-niveau ben ik parttime werkzaam als tandartsassistente. \r\nMijn hobby\'s zijn skiën, skaten, tennis ,zumba, naar de sauna gaan en soms uitgaan. Als ik uitga vind je me in een restaurantje, kroeg, bar dancing of de bioscoop. Ik hou van muziek uit de 80’s, 90’s en de hits van nu. Meestal staat Radio Veronica of Q-Music aan. \r\nIk ben graag onder de mensen en vind het leuk om met vrienden of vriendinnen af te spreken om een wijntje te drinken of met elkaar iets te ondernemen. \r\nMet vakantie ga ik het liefst ’s zomers naar zonnige bestemmingen en ’s winters op wintersport.\r\nTot slot wil ik nog zeggen dat ik in het bezit van een auto ben en niet rook.\r\n\r\nWanneer jij je kunt vinden in de bovenstaande beschrijving dan hoop ik je snel te spreken.\r\n\r\nGekke tekens: êëìíîïðaaAý\r\n',
    //             DT_PB: '2016-09-19 21:54:52',
    //         },
    //         foto_p2: 'https://mijn.partnerselect.net/img/avatar-voorstel-man.jpeg',
    //         aantal_extra_fotos_voorstel: 2,
    //         extra_fotos: [
    //             {
    //                 Volgorde: 1,
    //                 Volgordegetal: 14,
    //                 Bestandsnaam: 'https://www.hairfair.nl/media/blog/test-.jpg',
    //             },
    //             {
    //                 Volgorde: 1,
    //                 Volgordegetal: 1,
    //                 Bestandsnaam:
    //                     'https://mijn.partnerselect.net/pics_mijnps/9BAA83D7A53C6562A776E77F2C2BA98F7850B2A8_foto.jpg',
    //             },
    //         ],
    //         reacties_op_voorstel: [{ DT_ingevoerd: '2021-08-27 16:48:34' }],
    //     },
    //     {
    //         Klantnummer: '106057',
    //         KlantnummerREF: '8592',
    //         Voorstelnummer: '54681',
    //         InschrijfnummerREF: '1913',
    //         DatumA: '2021-08-27 00:00:00',
    //         DatumAf: '2021-08-27 00:00:00',
    //         Voornaam: 'Nieuwe',
    //         Openstaand: '1',
    //         Foto_code: '0',
    //         DT_foto_code_wijziging: '2021-09-22 11:09:52',
    //         Datum_Voorstel: '2021-08-27 00:00:00',
    //         persoonsbeschrijving_p2: {
    //             Relatornummer: '8592',
    //             DT_wijzig: '2021-07-23 16:48:34',
    //             PB: 'e, vlotte casual kleding en kom graag goed verzorgd voor de dag. \r\n\r\nSamen met mijn dochter van 13, mijn zoon van 8 en onze hond woon ik in een lekkere, royale woning met een heerlijke tuin en garage.\r\n\r\nJe kunt me het beste beschrijven met woorden als aardig, vlot, opgewekt, makkelijk, humor, spontaan, gezellig, hartelijk, vrouwelijk, zelfverzekerd, sportief, realistisch, actief, avontuurlijk, dominant, levenservaren, materialistisch, zelfstandig, positief, innemend, modieus, representatief en jeugdig. Belangrijk om te weten is dat ik vrijwel altijd goed gehumeurd ben!\r\n\r\nJe kunt me het beste beschrijven met "woorden" als aardig, vlot, opgewekt, makkelijk, humor, spontaan, gezellig, hartelijk, vrouwelijk, zelfverzekerd, sportief, realistisch, actief, avontuurlijk, dominant, levenservaren, materialistisch, zelfstandig, positief, innemend, modieus, representatief en jeugdig. Belangrijk om te weten is dat ik vrijwel altijd goed gehumeurd ben!\r\n\r\nNa mijn opleiding op MBO-niveau ben ik parttime werkzaam als tandartsassistente. \r\nMijn hobby\'s zijn skiën, skaten, tennis ,zumba, naar de sauna gaan en soms uitgaan. Als ik uitga vind je me in een restaurantje, kroeg, bar dancing of de bioscoop. Ik hou van muziek uit de 80’s, 90’s en de hits van nu. Meestal staat Radio Veronica of Q-Music aan. \r\nIk ben graag onder de mensen en vind het leuk om met vrienden of vriendinnen af te spreken om een wijntje te drinken of met elkaar iets te ondernemen. \r\nMet vakantie ga ik het liefst ’s zomers naar zonnige bestemmingen en ’s winters op wintersport.\r\nTot slot wil ik nog zeggen dat ik in het bezit van een auto ben en niet rook.\r\n\r\nWanneer jij je kunt vinden in de bovenstaande beschrijving dan hoop ik je snel te spreken.\r\n\r\nGekke tekens: êëìíîïðaaAý\r\n',
    //             DT_PB: '2016-09-19 21:54:52',
    //         },
    //         foto_p2: 'https://pickaface.net/gallery/avatar/unr_random_160817_0304_2mvqp69.png',
    //         aantal_extra_fotos_voorstel: 0,
    //         extra_fotos: [],
    //         reacties_op_voorstel: [],
    //     },
    // ],
};

export { parsedJson };
